import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { SUPPORTED, SUPPORTED_CODES, htmlLangFor } from "../i18n";

/**
 * SeoLang — <html lang> + hreflang (préfixes de chemin /fr /en /es /it /zh-cn /ja
 * + x-default) + canonical localisé, synchronisés avec la langue publique courante.
 * Architecture CRA (CSR) : injection client-side, sans SSR. Robots gérés ailleurs.
 * La vitrine Coming Soon conserve sa route publique non préfixée comme canonical.
 */
export default function SeoLang() {
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const lang = i18n.language;
    document.documentElement.lang = htmlLangFor(lang);

    const origin = window.location.origin;
    // Chemin sans préfixe de langue existant ni ?lng= résiduel.
    let path = location.pathname || "/";
    const seg = path.split("/")[1];
    if (SUPPORTED_CODES.includes((seg || "").toLowerCase())) {
      path = "/" + path.split("/").slice(2).join("/");
    }
    if (!path.startsWith("/")) path = "/" + path;

    const head = document.head;
    head.querySelectorAll('[data-i18n-seo="1"]').forEach((n) => n.remove());
    const mk = (rel, hreflang, href) => {
      const l = document.createElement("link");
      l.setAttribute("rel", rel);
      if (hreflang) l.setAttribute("hreflang", hreflang);
      l.setAttribute("href", href);
      l.setAttribute("data-i18n-seo", "1");
      head.appendChild(l);
    };
    const urlFor = (code) => (code === "fr" ? `${origin}${path}` : `${origin}/${code}${path === "/" ? "" : path}`);

    SUPPORTED.forEach((s) => mk("alternate", s.html, urlFor(s.code)));
    mk("alternate", "x-default", `${origin}${path}`);
    // LangEntry redirige les préfixes vers cette route publique réelle.
    // Ne pas canoniser la vitrine vers /en/coming-soon selon la langue du navigateur.
    const canonicalUrl = path === "/coming-soon" ? `${origin}${path}` : urlFor(lang);
    mk("canonical", null, canonicalUrl);
  }, [i18n.language, location.pathname, location.search]);

  return null;
}